import { Component, ViewEncapsulation} from '@angular/core'; 
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';  
import { AuthService } from '../../_services';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { LoaderService } from '../../_services/loader.service'; 
import { process, State,aggregateBy} from '@progress/kendo-data-query'; 
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings,DataStateChangeEvent,GridDataResult} from '@progress/kendo-angular-grid'; 
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import * as _moment from 'moment';  
import * as _rollupMoment from 'moment'; 
import { collectExternalReferences } from '@angular/compiler';
const moment = _rollupMoment || _moment;  
 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}; 

declare var $: any; 
const distinctZone = data => data.filter((x, idx, xs) => xs.findIndex(y => y.Zone === x.Zone) === idx);
const distinctSuplr = data => data.filter((x, idx, xs) => xs.findIndex(y => y.Supplier === x.Supplier) === idx); 
const distinctVeh = data => data.filter((x, idx, xs) => xs.findIndex(y => y.VehicleNo === x.VehicleNo) === idx); 

@Component({

  selector: 'plant-In',
  templateUrl: './transferStationDetails.component.html', 
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./plant.component.css']
  
})
//PlantReportComponent
export class transferStationDetails { 
    prjId:any; 
    prjName:any;
    showLoader:boolean; 
    startDate:any;
    endDate:any;
    defStartDt:any;
    defEndDt:any;
    dateRange:any;
    plantReportList:any;
    plantReportListMonthWise:any;
    totalCount:any;
    imageUrl:any;
    entityName:any;
    entityType:any;
    qrCd:any;
    serviceDate:any;
    totalInWaight:any;
    totalOutWaight:any;
    totalNetWaight:any; 
    header:any;
    swmReport:any;
    inWaitInTonne:any;
    outWaitInTonne:any;
    netInTonne:any;
    hideUlbColumn=false;
    swmHeadingHide=false;
    GFcolumnHide=false;
    GlLKcolumnHide=false;
    SuppliercolLKO=false;
    public aggregates: any[] = [{field: 'InWeight', aggregate: 'sum'},{field: 'OutWeight', aggregate: 'sum'},{field: 'NetWeight', aggregate: 'sum'}];
    public state: State = { 
      skip: 0,
      take: 13, 
      filter: {
      logic: 'and',
      filters: []
    }
  };
  public pageSize :any
  public checkboxOnly = false;
  public mode = 'multiple';
  public selectableSettings: SelectableSettings;

  public distinctZone: any[]
  public distinctSuplr: any[]
  public distinctVeh: any[]
 
  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>; 
  public hiddenColumns: string[] = [];
  public totalCountMonthWise: any;
  public distinctZoneMonthWise: any;
  public distinctSuplrMonthWise: any;
  public distinctVehMonthWise: any;
  public totalInWaightMonthWise: number;
  public inWaitInTonneMonthWise: number;
  public totalOutWaightMonthWise: number;
  public outWaitInTonneMonthWise: number;
  public totalNetWaightMonthWise: number;
  public netInTonneMonthWise: number;
  gridDataPlantReportMonthWise: DataResult;
  TripWisedata: any;
  public pitNumber: any;
  public selectDate: any;
  public updateDate: any;
  public limit: any;
  public UpdateValues: any;
  public checlvalues = true;
  public updatevaluescheck = false
  public successMsg = false;
  dataUpdateCheckbox: boolean;

  public PitDataModal :any;
  public list: any;
  public piTName: any;
  public TS_master_name: any;
  public pitNumbers_master: any;
  public pitNumberModal: any;
  public DisposeQuantityModal: any;
  public PitStatus:any;
  public PitStatusModal: any;
  public isHidden(columnName: string): boolean {
    return this.hiddenColumns.indexOf(columnName) > -1;
  } 
  
  public gridDataPlantReport: DataResult;
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  } 
  public allData(): ExcelExportData {
    const result: ExcelExportData =  {
        data: this.plantReportList
       
    };
    return result;
   } 
 
  private loadProducts(): void {
    this.gridDataPlantReport = process(this.plantReportList, { group: this.groups });  
  }
  constructor(private http : HttpClient ,private auth : AuthService,public routes: ActivatedRoute, public router: Router,private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) =>{
        this.showLoader = val;
      });
    this.allData = this.allData.bind(this);
    var date = new Date(); 
    //var firstDay = new Date(date.getFullYear(), date.getMonth(), 1); 
    this.defStartDt = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate(); 
    this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
    this.dateRange= {beginDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}, 
                     endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}};


                     
   this.PitStatus =  [
         { id: 1, PitStatusName: 'Full' },
         { id: 2, PitStatusName: 'Empty' }
      ]

   
   }  
  



    ActionData = [
    { id: 1, name: 'Data Add' },
    { id: 2, name: 'Data Remove' }
   ]







   /*
    * get Mobility Service Report
   */ 
   getTSDataDetail(){   
         this.loaderService.display(true); 
        
          this.http.get(environment.apiUrl + 'reports/getTSDataDetail?fromDt='+this.startDate+'&toDt='+this.endDate).subscribe(data =>{ 
                this.plantReportList=data;  
                this.gridDataPlantReport = process(this.plantReportList, this.state);   
                this.loaderService.display(false); 
             
              });  


   } 





/*
 * filter The Date
*/
  public dataStateChange(state: DataStateChangeEvent): void {
  this.state = state;
  this.gridDataPlantReport = process(this.plantReportList, this.state);  
  if (state && state.group) {  
      state.group.map(group => group.aggregates = this.aggregates);
      //this.totalCount= this.gridDataPlantReport.data.length       
      this.totalInWaight = aggregateBy(this.gridDataPlantReport.data, this.aggregates)["InWeight"].sum;  
      //this.inWaitInTonne=Number(this.totalInWaight)/1000 
      this.totalOutWaight = aggregateBy(this.gridDataPlantReport.data, this.aggregates)["OutWeight"].sum; 
      //this.outWaitInTonne=Number(this.totalOutWaight)/1000  
      this.totalNetWaight = aggregateBy(this.gridDataPlantReport.data, this.aggregates)["NetWeight"].sum; 
      //this.netInTonne=Number(this.totalNetWaight)/1000  
      this.gridDataPlantReport = process(this.plantReportList, this.state); 
    } 
} 

/*
*select start Date Nad To date
*/
 onDateRangeChanged(dataRange)
 {  
   if(dataRange.beginDate.day>0){ 
     this.startDate= dataRange.beginDate.year + "-"  + dataRange.beginDate.month+ "-" + dataRange.beginDate.day 
     this.endDate = dataRange.endDate.year + "-"  + dataRange.endDate.month  + "-" + dataRange.endDate.day 

     console.log(this.startDate,this.endDate,12345);
     
     this.getTSDataDetail(); 
    
   }
   else if(dataRange.beginDate.day==0){
     this.startDate= this.defStartDt
     this.endDate = this.defEndDt
     this.getTSDataDetail(); 
    
   }  
 } 
  

 /*
  *Select Export PDF header 
 */
 selectPdfHeader(){
   if(this.prjId==1){
     this.header="Ecogreen Energy Lucknow Pvt. Ltd."
     this.swmReport="Lucknow" 
   }
  else if(this.prjId==2 ||this.prjId==3){
    this.header="Ecogreen Energy Gurgaon Faridabad Pvt. Ltd."
    this.swmReport="Faridabad"
  }
  else{
    this.header="Ecogreen Energy Gwalior Pvt. Ltd."
    this.swmReport="ISWM, WTE Project, Sivpuri Link Road,Gwalior."
  }
 } 
 
    ngOnInit() {  
        this.startDate = moment(this.defStartDt).format('YYYY-MM-DD');
        this.endDate= moment(this.defEndDt).format('YYYY-MM-DD');
        this.prjId = this.auth.getAuthentication().projectId
        if(this.prjId==1){
          this.prjName="LUCKNOW";
          this.swmHeadingHide=true;
          this.SuppliercolLKO=false;  
          this.GlLKcolumnHide=true;
        }
        else if(this.prjId==2){
          this.prjName="GURUGRAM";
          this.swmHeadingHide=true;
          this.GFcolumnHide=true
          this.GlLKcolumnHide=false;
        }
        else if(this.prjId==3){
          this.prjName="FARIDABAD"; 
          this.swmHeadingHide=true;
          this.GFcolumnHide=true
          this.GlLKcolumnHide=false;
        }
        else if(this.prjId==4){
          this.prjName="GWALIOR";
          this.hideUlbColumn=true
          this.GlLKcolumnHide=true;
        } 
        // this.getTSDataDetail();
        // this.selectPdfHeader();


        this.get_TS_master_details()

        // this.GetPitData('Badshahpur MRF Z4')

       // this.exportTripWise()
    }


    downloadExcelFile(TripWisedata) {
      console.log(TripWisedata);
      
      const ws_name = 'Trip Wise data';
      const wb: WorkBook = { SheetNames: [], Sheets: {} };
      const ws: any = utils.json_to_sheet(TripWisedata);
      wb.SheetNames.push(ws_name);
      wb.Sheets[ws_name] = ws;
      const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
      saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),'TripWisedata.xlsx');
    }
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    }

    
    exportTripWise(){
      this.startDate = moment(this.startDate).format('YYYY-MM-DD');
      this.endDate= moment(this.endDate).format('YYYY-MM-DD');

      console.log('reports/getTripWisedata?fromDt='+this.startDate+'&toDt='+this.endDate+'&prjid='+this.prjId);
      

      this.http.get(environment.apiUrl + 'reports/getTripWisedata?fromDt='+this.startDate+'&toDt='+this.endDate+'&prjid='+this.prjId).subscribe(data =>{ 

        this.TripWisedata = data

        this.downloadExcelFile(this.TripWisedata)
    });  
      
   }

 
 
   PitDetails(item){
      


    console.log(item,333);
    

    $('#SavePitData').modal('show', null);


  }







  sendPitDetails(){
       
    console.log(this.pitNumber,339);

    // this.list = [
    //       {id:'1'},
    //       {id:'2'},
    //       {id:'3'},
    //       {id:'4'},
    //       {id:'4'},
    //       {id:'1'},
    //       {id:'1'},
    //       {id:'1'},
    //       {id:'2'},
    //       {id:'3'},
    //       {id:'4'},
    //       {id:'4'},
    //       {id:'4'}
          
    // ];


    var  pitjason = {

      'pitnumber':this.pitNumberModal,
      'pitname':this.piTName ,
      'qty':this.DisposeQuantityModal,
      'status':this.PitStatusModal

    }


    console.log(pitjason);
    


    // this.http.post(environment.apiUrl + 'reports/savePitDeatils', pitjason).subscribe((data) => {
     
      
     
   
    // });



    

  }


  GetPitData(data){

   this.piTName = data
   this.loaderService.display(true); 

   this.http.get(environment.apiUrl + 'reports/GetPitData?tsname='+this.piTName).subscribe(data =>{ 

      console.log(data,394);

      this.list  = data
  
     this.loaderService.display(false); 
  
   });  

     

  }



  get_TS_master_details(){   
    this.loaderService.display(true); 
   
     this.http.get(environment.apiUrl + 'reports/get_TS_master_details').subscribe(data =>{ 

          this.TS_master_name = data ;
          
           this.loaderService.display(false); 
        
         });  
 } 


  onChangeData(data){

  this.PitDataModal = data.name

  this.http.get(environment.apiUrl + 'reports/get_pit_master_id_details?tsname='+this.PitDataModal).subscribe(data =>{ 

    this.pitNumbers_master = data ;



    console.log(this.pitNumbers_master,415 );
    



    
     this.loaderService.display(false); 
  
   });  

  } 



  savetsData(){

    alert('test')



    console.log('', this.PitDataModal);
    console.log('',this.pitNumberModal);
    console.log('',this.DisposeQuantityModal);
    
    


  }



 





}
  
  
  


   


 
 

 



 


// WEBPACK FOOTER //
// ./src/app/reports/plant/transferStationDetails.component.ts